import type { PublicSlotKey } from '#packages/apilib';
import type { WixDataApi } from './api';

export const WixDataApiKey: PublicSlotKey<WixDataApi> = {
  name: 'WixDataApi',
  public: true,
};
